<template>
  <div :class="divClass">{{ yk }}</div>
</template>

<script>
export default {
  name: 'YkText',
  props: {
    num: [String, Number],
    pd: [String, Number]
  },
  data () {
    return {
      yk: '',
      divClass: 'red'
    }
  },
  created () {
    if (this.pd !== '') {
      const num = Number(this.num)
      const pd = Number(this.pd)
      const yk = pd - num
      if (yk > 0) {
        this.divClass = 'green'
      } else {
        this.divClass = 'red'
      }
      this.yk = yk
    } else {
      this.yk = ''
    }
  },
  methods: {},
  watch: {
    'pd' () {
      if (this.pd !== '') {
        const num = Number(this.num)
        const pd = Number(this.pd)
        const yk = pd - num
        if (yk > 0) {
          this.divClass = 'green'
        } else {
          this.divClass = 'red'
        }
        this.yk = yk
      } else {
        this.yk = ''
      }
    }
  }
}
</script>
<style scoped>
  .red {
    color: red;
    text-align: right;
  }
  .green {
    color: green;
    text-align: right;
  }
</style>
